<template>
  <v-card class="ma-2">
    <v-card-title>新增供應商</v-card-title>
    <v-card-text>
      <v-divider />
      <merchant-form :loading="loading" @submit="submit"></merchant-form>
    </v-card-text>
  </v-card>
</template>

<script>
import api from '@/api';
import Swal from 'sweetalert2';
import MerchantForm from './Form.vue';

const { merchant } = api;

export default {
  components: { MerchantForm },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async submit(form) {
      if (form) {
        this.loading = true;
        const { status } = await merchant.add(form);
        this.loading = false;
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '新增成功' });
          await this.$router.back();
        }
      }
    },
  },
};
</script>

<style>
</style>
